import { memo, useMemo } from "react";

import { scopeSvgIds } from "./scopeSvgIds";

/** Sticker SVG inlined with its ids scoped, so copies never collide. */
export const StickerArt = memo(function StickerArt({
  markup,
  scope,
}: {
  markup: string;
  scope: string;
}) {
  const html = useMemo(() => scopeSvgIds(markup, scope), [markup, scope]);
  return (
    <div
      className="widget-sticker"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
});
